import { useRouter } from 'expo-router'
import React from 'react'
import { StyleSheet, TouchableOpacity, View } from 'react-native'
import { useThrottledCallback } from 'use-debounce'
import { DS } from '@/design-system'
import { useStore } from '@/models'

import { DiamondsBalance } from '@/screens/diamonds/components/DiamondsBalance'

const NAVIGATION_THROTTLE_MS = 1000

interface DiamondsSummaryCardProps {
  /** Small caption heading rendered inside the card (profile style). Omit for a bare card. */
  title?: string
  /** Analytics event name fired on tap (e.g. events.diamonds.teaser_tapped). */
  analyticsEvent: string
}

export function DiamondsSummaryCard({ title, analyticsEvent }: DiamondsSummaryCardProps) {

  const router = useRouter()
  const {
    analytics: { setEvent }
  } = useStore()

  const onPress = useThrottledCallback(() => {
    setEvent(analyticsEvent, {})
    router.push('/diamonds')
  }, NAVIGATION_THROTTLE_MS)

  return (
    <TouchableOpacity onPress={onPress} activeOpacity={0.7}>
      <View style={styles.wrapper}>
        <View style={styles.content}>
          {title ? (
            <DS.Text variant="Caption/Bold" uppercase>
              {title}
            </DS.Text>
          ) : null}
          <DiamondsBalance />
        </View>
        <DS.Icon name="Arrow---right" size={20} color="Global/Black" />
      </View>
    </TouchableOpacity>
  )
}

const styles = StyleSheet.create({
  wrapper: {
    backgroundColor: DS.palette['Global/White'],
    borderRadius: DS.spacing[8],
    flexDirection: 'row',
    alignItems: 'center',
    padding: DS.spacing[16],
    gap: DS.spacing[12]
  },
  content: {
    flex: 1,
    gap: DS.spacing[12]
  }
})
